"use strict";

const WRAP_SELECTOR = "[data-resellers-form-wrap]";
const FORM_SELECTOR = "[data-resellers-form]";
const NOTIFY_SELECTOR = "[data-resellers-form-notify]";
const SUBMIT_SELECTOR = "[data-resellers-form-submit]";
const AJAX_ACTION = "resellers_form_action";
const REVERSE_GEOCODING = true;

function setNotify(notify, type, message) {
    if (!notify) {
        return;
    }

    notify.className = "form-notify";

    if (type) {
        notify.classList.add(type);
    }

    notify.textContent = message || "";
}

function updateInterestCards(form) {
    form.querySelectorAll("[data-resellers-interest-card]").forEach((card) => {
        const input = card.querySelector('input[type="radio"]');
        card.classList.toggle("is-selected", Boolean(input?.checked));
    });
}

function pushLeadEvent(tracking) {
    if (!tracking) {
        return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: "lead_submit",
        interesse: tracking.interesse,
        cap: tracking.cap,
        geo_source: tracking.geo_source,
        consenso_marketing: tracking.consenso_marketing,
    });
}

function initResellersForm(wrap) {
    const form = wrap.querySelector(FORM_SELECTOR);

    if (!form) {
        return;
    }

    const notify = form.querySelector(NOTIFY_SELECTOR);
    const submitButton = form.querySelector(SUBMIT_SELECTOR);
    const successBox = wrap.querySelector("[data-resellers-success]");
    const restartButton = wrap.querySelector("[data-resellers-restart]");
    const capInput = form.querySelector("[data-resellers-cap]");
    const latInput = form.querySelector("[data-resellers-lat]");
    const lngInput = form.querySelector("[data-resellers-lng]");
    const geoBtn = form.querySelector("[data-resellers-geo-btn]");
    const geoLabel = form.querySelector("[data-resellers-geo-label]");
    const geoDenied = form.querySelector("[data-resellers-geo-denied]");
    const geoIdleBox = form.querySelector("[data-resellers-geo-idle]");
    const geoOkBox = form.querySelector("[data-resellers-geo-success]");
    const geoAccuracy = form.querySelector("[data-resellers-geo-accuracy]");

    const labelGeo = wrap.dataset.labelGeo || "";
    const labelGeoLoading = wrap.dataset.labelGeoLoading || "";

    if (capInput) {
        capInput.addEventListener("input", () => {
            capInput.value = capInput.value.replace(/\D/g, "").slice(0, 5);
        });
    }

    form.querySelectorAll("[data-resellers-interest-card]").forEach((card) => {
        card.addEventListener("change", () => updateInterestCards(form));
    });

    if (!("geolocation" in navigator)) {
        if (geoIdleBox) {
            geoIdleBox.hidden = true;
        }
    } else if (geoBtn) {
        geoBtn.addEventListener("click", () => {
            geoBtn.disabled = true;

            if (geoLabel) {
                geoLabel.textContent = labelGeoLoading;
            }

            if (geoDenied) {
                geoDenied.hidden = true;
            }

            navigator.geolocation.getCurrentPosition(
                (pos) => {
                    if (latInput) {
                        latInput.value = String(pos.coords.latitude);
                    }

                    if (lngInput) {
                        lngInput.value = String(pos.coords.longitude);
                    }

                    if (geoAccuracy) {
                        geoAccuracy.textContent = String(Math.round(pos.coords.accuracy));
                    }

                    if (geoIdleBox) {
                        geoIdleBox.hidden = true;
                    }

                    if (geoOkBox) {
                        geoOkBox.hidden = false;
                    }

                    if (REVERSE_GEOCODING) {
                        const url =
                            "https://nominatim.openstreetmap.org/reverse?format=json&lat=" +
                            pos.coords.latitude +
                            "&lon=" +
                            pos.coords.longitude +
                            "&zoom=18&addressdetails=1";

                        fetch(url, { headers: { "Accept-Language": "it" } })
                            .then((res) => res.json())
                            .then((data) => {
                                if (data?.address?.postcode && capInput) {
                                    capInput.value = String(data.address.postcode)
                                        .replace(/\D/g, "")
                                        .slice(0, 5);
                                }
                            })
                            .catch(() => {
                                /* CAP resta manuale */
                            });
                    }
                },
                () => {
                    geoBtn.disabled = false;

                    if (geoLabel) {
                        geoLabel.textContent = labelGeo;
                    }

                    if (geoDenied) {
                        geoDenied.hidden = false;
                    }
                },
                { enableHighAccuracy: true, timeout: 8000, maximumAge: 60000 }
            );
        });
    }

    form.addEventListener("submit", async (event) => {
        event.preventDefault();

        if (!window.WPURLS?.ajaxUrl) {
            return;
        }

        if (!form.checkValidity()) {
            form.reportValidity();
            return;
        }

        const defaultMessage = window.WPURLS.mail_message?.error || "";
        const sendingMessage = window.WPURLS.mail_message?.sending || "";

        if (submitButton) {
            submitButton.disabled = true;
        }

        setNotify(notify, "info", sendingMessage);

        const data = new FormData(form);
        data.append("action", AJAX_ACTION);

        try {
            const response = await fetch(window.WPURLS.ajaxUrl, {
                method: "POST",
                credentials: "same-origin",
                body: data,
            });

            const payload = await response.json();
            const isSuccess = Boolean(payload?.success);

            if (isSuccess) {
                pushLeadEvent(payload?.tracking);
                setNotify(notify, "", "");
                form.hidden = true;

                if (successBox) {
                    successBox.hidden = false;
                }
            } else {
                setNotify(notify, "error", payload?.message || defaultMessage);
            }
        } catch (error) {
            setNotify(notify, "error", defaultMessage);
        } finally {
            if (submitButton) {
                submitButton.disabled = false;
            }
        }
    });

    if (restartButton) {
        restartButton.addEventListener("click", () => {
            form.reset();
            updateInterestCards(form);
            setNotify(notify, "", "");

            if (latInput) {
                latInput.value = "";
            }

            if (lngInput) {
                lngInput.value = "";
            }

            if (geoOkBox) {
                geoOkBox.hidden = true;
            }

            if (geoIdleBox) {
                geoIdleBox.hidden = !("geolocation" in navigator);
            }

            if (geoBtn) {
                geoBtn.disabled = false;
            }

            if (geoLabel) {
                geoLabel.textContent = labelGeo;
            }

            if (geoDenied) {
                geoDenied.hidden = true;
            }

            if (successBox) {
                successBox.hidden = true;
            }

            form.hidden = false;
        });
    }
}

function initResellersForms() {
    document.querySelectorAll(WRAP_SELECTOR).forEach(initResellersForm);
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initResellersForms, { once: true });
} else {
    initResellersForms();
}
